import React from 'react';
import styled from 'styled-components';

import { space, layout, flexbox, position, color, typography } from 'styled-system';
import theme from '@styles/theme';
const DEFAULT_EL = 'span';

export default class Text extends React.Component {
  render() {
    const {
      is = DEFAULT_EL,
      noWrap,
      truncate,
      textStyle,
      style = {},
      ...props
    } = this.props;
    let mergedStyles = { ...style };

    const Base = styled(is)(
      {
        margin: 0
      },
      space,
      layout,
      flexbox,
      position,
      color,
      typography
    );

    Base.displayName = 'Text';

    if (truncate) {
      mergedStyles = {
        ...mergedStyles,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      };
    }
    if (noWrap) {
      mergedStyles = {
        ...mergedStyles,
        whiteSpace: 'nowrap'
      };
    }
    return (
      <Base
        {...(textStyle ? theme.textStyles[textStyle] : {})}
        style={mergedStyles}
        {...props}
      />
    );
  }
}

Text.displayXXLarge = props => <Text textStyle="displayXXLarge" {...props} />;
Text.displayXLarge = props => <Text textStyle="displayXLarge" {...props} />;
Text.displayLargeHeader = props => <Text textStyle="displayLargeHeader" {...props} />;
Text.displayLarge = props => <Text textStyle="displayLarge" {...props} />;
Text.displayMedium = props => <Text textStyle="displayMedium" {...props} />;
Text.displaySmall = props => <Text textStyle="displaySmall" {...props} />;
Text.body = props => <Text textStyle="body" {...props} />;
Text.largeCaption = props => <Text textStyle="largeCaption" {...props} />;
Text.caption = props => <Text textStyle="caption" {...props} />;
Text.smallCaption = props => <Text textStyle="smallCaption" {...props} />;
Text.graphLabel = props => <Text textStyle="graphLabel" {...props} />;
Text.bold = props => <Text fontWeight="bold" {...props} />;

// Website styles
Text.websiteXLarge = props => <Text textStyle="websiteXLarge" {...props} />;
Text.websiteLarge = props => <Text textStyle="websiteLarge" {...props} />;
Text.websiteMedium = props => <Text textStyle="websiteMedium" {...props} />;
Text.contentBody = props => (
  <Text
    {...props}
    textStyle="body"
    style={{ lineHeight: 1.8, fontSize: '18px', fontFamily: 'Lato' }}
  />
);
